import { assert } from '../../../app/logger.js';
import { Coords } from '../../coords.js';

/**
 * Polyline base class for maps API wrappers.
 */
const PolylineBaseMixin = Base =>
  class extends Base {
    constructor(options) {
      super(options);

      assert(options, `[map:marker] no options is given for PolylineBaseMixin`);
      assert(options.map, `[map:marker] no map is given for PolylineBaseMixin`);
      this.map = options.map;
    }

    get type() {
      return 'polyline';
    }

    /**
     * Returns route's center position relative map's center if
     * the route is visible and is in view.
     */
    async getCenterPos() {
      if (!this.attached || !this.visible) {
        return null;
      }

      let path = this.path;
      if (!path) {
        return null;
      }

      // Get a point between points if the path is two points long.
      // Otherwise pick up a point from the middle of the path.
      let startIndex = Math.floor(path.length / 2) - 1;
      let endIndex = path.length > 2 ? startIndex : Math.floor(path.length / 2);

      let start = path[startIndex];
      let end = path[endIndex];
      if (!start || !end) {
        return null;
      }

      let [startX, startY] = await Coords.toClient(
        this.map,
        start.lat,
        start.lng
      );
      let [endX, endY] = await Coords.toClient(this.map, end.lat, end.lng);

      let x = Math.round((endX + startX) / 2);
      let y = Math.round((endY + startY) / 2);

      let rect = this.map.el.getBoundingClientRect();
      if (x < 0 || x > rect.width || y < 0 || y > rect.height) {
        return null;
      }

      let centerX = Math.round((rect.right - rect.left) / 2);
      let centerY = Math.round((rect.bottom - rect.top) / 2);

      return {
        x: x - centerX,
        y: y - centerY,
      };
    }
  };

export { PolylineBaseMixin };
